import * as types from '../actionTypes'

const initialState = {
  ePayResult: null,
  showSeeYouLater: false,
  clearedAmount: null,
  errorMessage: null,
  paymentInfo: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.START_PAYMENT_SUCCESS: {
      return {
        ...state,
        ePayResult: action.payload,
        paymentInfo: action.paymentInfo
      }
    }

    case types.SHOW_SEE_YOU_LATER: {
      return {
        ...state,
        showSeeYouLater: action.payload
      }
    }

    case types.PAYMENT_CLEARED: {
      return {
        ...state,
        clearedAmount: action.payload,
        showSeeYouLater: false,
        paymentInfo: null
      }
    }

    case types.SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        errorMessage: action.payload,
        showSeeYouLater: false,
        paymentInfo: null
      }
    }

    case types.NAVIGATE_TO_SEARCH: {
      return {
        ...state,
        errorMessage: null,
        clearedAmount: null,
        ePayResult: null,
        paymentInfo: null
      }
    }

    default:
      return state
  }
}
